<script lang="ts">
  import { type OrgType, ROLES_BY_ORG_TYPE, type Role } from '@clinic/contracts';
  import { useOrg } from '../../../shared/auth/org.svelte';
  import { fa } from '../../../shared/i18n/fa';
  import { CheckboxLabel } from '../../../shared/ui';

  /** Only roles valid for this organization type are offered; the server enforces the same rule. */
  let {
    orgType,
    value,
    onChange,
    disabled,
  }: { orgType: OrgType; value: readonly Role[]; onChange: (roles: Role[]) => void; disabled?: boolean } = $props();

  const org = useOrg();
  const LASER: readonly Role[] = ['laser_receptionist', 'laser_operator'];
  // Without laser (ADR-043) its roles are not offered; one a member already holds stays visible.
  const roles = $derived(
    ROLES_BY_ORG_TYPE[orgType].filter((r) => org.laserEnabled || !LASER.includes(r) || value.includes(r)),
  );
</script>

<fieldset class="flex min-w-0 flex-wrap gap-1" {disabled}>
  <legend class="sr-only">{fa.members.roles}</legend>
  {#each roles as role (role)}
    <CheckboxLabel
      label={fa.roles[role]}
      checked={value.includes(role)}
      onChange={(checked) => onChange(checked ? [...value, role] : value.filter((r) => r !== role))}
    />
  {/each}
  {#if orgType === 'clinic' && org.laserEnabled}<p class="w-full text-xs text-text-3">{fa.members.laserRolesHint}</p>{/if}
</fieldset>
